import { useTranslation } from "react-i18next";
import specterLoginApp from "../../images/specter-login.png";
import specterLoginSmApp from "../../images/specter-login-sm.png";

const HowWorks = () => {
  const { t } = useTranslation();

  const features = [
    {
      title: t("features.scan_qr.title"),
      description: t("features.scan_qr.description"),
    },
    {
      title: t("features.digital_storage.title"),
      description: t("features.digital_storage.description"),
    },
    {
      title: t("features.rewards.title"),
      description: t("features.rewards.description"),
    },
  ];

  return (
    <section className="bg-surface">
      <div className="container mx-auto py-32 flex flex-col justify-center items-center gap-14">
        <h1 className="flex flex-wrap justify-center gap-2 text-black text-4xl font-bold text-center text-nowrap px-8 md:px-0">
          {t("howWorks.title")}{" "}
          <span className="text-primaryDark">{t("common.specter")}</span>
          {t("howWorks.subtitle")}
          {t("common.questionMark")}{" "}
        </h1>

        <div className="w-full flex flex-col md:flex-row items-center gap-4">
          <div className="w-full md:w-1/2 flex justify-center">
            <img
              src={specterLoginApp}
              className="hidden md:block"
              alt="Specter App"
            />
            <img
              src={specterLoginSmApp}
              className="block md:hidden"
              alt="Specter App"
            />
          </div>

          <div className="w-full md:w-1/2 space-y-10 px-4">
            {features.map((feature, index) => (
              <div
                key={index}
                className="relative group flex items-start gap-4 border border-grayDark rounded-20 px-5 py-9 bg-white 
  overflow-hidden transition-all duration-500 hover:shadow-xl"
              >
                <span className="absolute inset-0 rounded-20 bg-gradient-to-r from-transparent via-primary/30 to-transparent opacity-0 group-hover:opacity-100 group-hover:animate-[shine_1.2s_linear]" />

                <div className="relative w-16 h-14 shrink-0 flex justify-center items-center rounded-20 bg-primary/10 text-primary text-2xl md:text-4xl font-bold transition-transform duration-500 group-hover:scale-110">
                  {index + 1}
                </div>

                <div className="relative flex flex-col">
                  <p className="text-black text-xl font-bold mb-4">
                    {feature.title}
                  </p>
                  <p className="text-grayDark">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowWorks;
